module.exports = __webpack_public_path__ + "img/no_image.2b771229.svg";